import styles from './project.module.css';
import OneSkill from '../Skills/OneSkill'


const IndPro=()=>{
    return <div className={styles.projects_container}>
    <div className={styles.project}>
      <div className={styles.project_videocontainer}>
        <div data-aos="fade-right">
          <img
            src="https://i.ibb.co/nk99ZvR/lyndaPic.png"
            alt="LinkedIn_Learning"
          />
        </div>
      </div>
      <div className={styles.project_information}>
        <h2>LinkedIn Learning</h2>
        <p>
Linkedin has millions of users across the globe. Several posts and active users make LinkedIn very popular. So as a part of Linkedin Lynda also has millions of users. Linkedin invented Lynda as their learning platform. Lynda has hundreds of courses. The users who have the l Linkedin premium subscription also have access to Lynda.</p>
        <div className={styles.project_skills}> 
        <OneSkill skill="vscode-icons:file-type-html" sName="HTML"/><OneSkill/>
        <OneSkill skill="vscode-icons:file-type-css" sName="CSS"/><OneSkill/>
        <OneSkill className={styles.icon_rotate} skill="logos:react" sName="React.js"/><OneSkill/>
        <OneSkill skill="logos:javascript" sName="JavaScript"/><OneSkill/>
        <OneSkill skill="logos:redux" sName="Redux"/><OneSkill/>
        <OneSkill className={styles.icon_invert} skill="logos:express" sName="Express.js"/><OneSkill/>
        <OneSkill skill="logos:nodejs-icon" sName="Node.js"/><OneSkill/>
        <OneSkill skill="logos:mongodb" sName="MongoDB"/><OneSkill/>
        
        </div>
        <div>
          <a
            href="https://ankitkumar3443.github.io/LinkedinLearning.github.io"
            target="_blank"
            rel="noreferrer"
          >
            <span type="button" className="btn-blue_active">
              See this Live
            </span>
          </a>
          <a
            href="https://github.com/ankitkumar3443/Llinkedin_learning"
            target="_blank"
            rel="noreferrer"
          >
            <span type="button" className="btn-blue">
              View Code
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
}

export default IndPro;
